// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1074":"0caa1d10fadcf649","5454":"4e8ffcdd6c792b28"}[chunkId] + ".css";
};